import { useRef } from 'react';

import { useAppContext } from '../../../app/Context';

const useLayoutVM = () => {
  const { session } = useAppContext();

  return { session };
};

export default useLayoutVM;
